import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M6.54 10.94a.74.74 0 0 1-.54-.22L4.55 9.26a.75.75 0 0 1 0-1.06.74.74 0 0 1 1.06 0l.93.93 3.85-3.85a.75.75 0 0 1 1.06 1.06l-4.38 4.38a.73.73 0 0 1-.53.22ZM14.75 8A6.75 6.75 0 1 0 8 14.75 6.76 6.76 0 0 0 14.75 8Zm-1.5 0A5.25 5.25 0 1 1 8 2.75 5.26 5.26 0 0 1 13.25 8Z';
const draw24px =
  'M9.94,15.75a.74.74,0,0,1-.53-.22l-2-2.06a.74.74,0,0,1,0-1.06.75.75,0,0,1,1.06,0l1.52,1.53L15.58,8.3a.75.75,0,0,1,1.06,0,.74.74,0,0,1,0,1.06l-6.17,6.17A.73.73,0,0,1,9.94,15.75ZM21.75,12A9.75,9.75,0,1,0,12,21.75,9.76,9.76,0,0,0,21.75,12Zm-1.5,0A8.25,8.25,0,1,1,12,3.75,8.26,8.26,0,0,1,20.25,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CheckmarkCircleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'checkmarkCircle')) as IconWithRender;

CheckmarkCircleIcon.displayName = 'CheckmarkCircleIcon';
CheckmarkCircleIcon.propTypes = Icon.propTypes;
CheckmarkCircleIcon.renderIcon = (props) => <CheckmarkCircleIcon {...props} />;
export default CheckmarkCircleIcon;
